<template>
  <!-- -->
  <div class="yq-empty">
    <img src="@/assets/image/icon/no-message.png" alt="" class="empty-icon"/>
    <div class="empty-text">{{description}}</div>
  </div>
</template>

<script>


export default {
  props: {
    description: {default: "暂无数据"}
  },
  name: "",
  components: {
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.yq-empty{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  .empty-icon{
    width: 100%;
    max-width: 150px;
  }
  .empty-text{
    text-align: center;
    color: var(--yq-font-color-desc);
  }
}
</style>